module.exports = "pegasus/assets/film.png";